import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { UserProductGroup, UserProductGroupErrorResponse } from '~/Api/User/ProductGroup';
import { handleError } from '~/ErrorHandler';
import { flashErrorMessage } from '~/FlashMessage';
import { logGoogleTagManagerDeleteProductGroup } from '~/GoogleTagManager';
import { redirectFromDeletedGroup, removeGroup } from '~/ProductGroup';
import { State as ApplicationState, ThunkDispatch } from '~/Store';
import DeleteModal from '~/UI/DeleteModal/DeleteModal';

type Props = {
	group: UserProductGroup;
	onClose?: () => void;
	onConfirm?: (group: UserProductGroup) => void;
};

function mapStateToProps(
	state: ApplicationState,
	props: Props
): {
	title: string;
	isFetching: boolean;
} {
	return {
		title: `Delete list: ${props.group.name}`,
		isFetching: state.productGroup.removeRequest !== null,
	};
}

function mapDispatchToProps(
	dispatch: ThunkDispatch<AnyAction>,
	props: Props
): {
	onConfirm: () => void;
} {
	return {
		onConfirm: () =>
			dispatch(removeGroup(props.group.id))
				.then(() => {
					logGoogleTagManagerDeleteProductGroup(props.group.id, props.group.name);
					props.onConfirm?.(props.group);
				})
				.catch((response) => {
					if (!(response instanceof UserProductGroupErrorResponse)) {
						dispatch(handleError(response));
						return;
					}
					if (response.handleProductGroupNotFound()) {
						props.onClose?.();
						dispatch(redirectFromDeletedGroup(props.group));
					}
					if (response.handleProductGroupLocked()) {
						dispatch(flashErrorMessage('Product list cannot be deleted now, please try again'));
						props.onClose?.();
					}
					dispatch(handleError(response));
				}),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteModal);
